import {
  policyNumberSearch,
  simplePolicyNumberSearch
} from "@/api/search.service";
import { searchCaseTransactions } from "@/api/transactions.service";

export const usePolicySearch = () => {
  return {
    itemTitle: i => i.policyNumber,
    comparisonValue: v => v.id,
    fetchResults: async (search, searchArgs) => {
      let method = policyNumberSearch;
      if (searchArgs.transaction) {
        method = v => searchCaseTransactions({ policy_number: v });
      } else if (searchArgs.simple) {
        method = simplePolicyNumberSearch;
      }

      return method(search);
    }
  };
};
